import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "At Mobikode Houston, we’re here to listen, help, and deliver dependable solutions that keep your business moving forward.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise",
        description: "At Mobikode Houston, we build smart digital solutions that help businesses grow, connect, and thrive.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "At Mobikode, we build tailored digital solutions that simplify work, solve real challenges, and help Houston businesses grow confidently.",
        image: "/assets/mumbai/img2.png"
    },
];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we help financial businesses in Houston work smarter, serve customers better, and grow with secure, reliable technology built around their needs.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help Houston eCommerce businesses grow with smart, dependable digital solutions that simplify operations, strengthen customer experiences, and drive lasting success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Houston’s insurance companies work smarter with secure digital solutions that simplify operations, streamline claims and policies, enhance customer experiences, and support sustainable growth.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we help Houston manufacturers adopt smarter technology, streamline operations, boost productivity, and create efficient processes that drive sustainable business growth.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode Houston, we help retail and consumer brands grow with practical digital solutions that make customer experiences better, operations easier, and businesses ready for what’s next.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help Houston’s Healthcare and Life Sciences organizations use technology to simplify care, empower teams, and create better experiences for patients.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "At Mobikode, we help Houston’s media and communications businesses blend technology and creativity to connect audiences, simplify operations, and build lasting engagement.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help Houston’s logistics and transportation businesses simplify operations, improve delivery experiences, and grow confidently with practical digital solutions built for everyday challenges.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help Houston’s technology companies turn ideas into meaningful digital solutions, combining creativity and expertise to build reliable technology that drives growth.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we help Houston’s nonprofit organizations use technology to reach more people, simplify everyday work, and create lasting impact within the communities they serve.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help Houston’s professional service businesses simplify processes, adopt smarter technology, and deliver better client experiences through practical, reliable digital solutions.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we help Houston’s real estate businesses grow with smart digital solutions that simplify operations, improve experiences, and connect builders, agents, and buyers.",
        image: "/assets/mumbai/item12.png"
    },
];

function Houston() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Houston | ITSM & Automation | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode delivers ServiceNow consulting in Houston to help businesses streamline IT operations, automate workflows, integrate enterprise systems, and improve service management with scalable digital solutions."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Houston, ServiceNow Consultant Houston, ServiceNow Implementation Houston, ServiceNow Integration Houston, ServiceNow ITSM Houston, ServiceNow Managed Services Houston, ServiceNow Automation Houston, ServiceNow Development Houston, ServiceNow Solutions Houston, ServiceNow Consulting Company Houston"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-houston"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Houston | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Transform service management with Mobikode's ServiceNow consulting solutions in Houston. Improve workflows, automate processes, connect business systems, and build efficient digital operations."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-houston"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/melbourne/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Houston | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Get tailored ServiceNow consulting solutions in Houston for IT service management, workflow automation, system integration, and Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/melbourne/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Houston" description="Partner with Mobikode’s ServiceNow experts in Houston to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/houston.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />

            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Houston
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode’s ServiceNow experts in Houston to simplify work, automate workflows, empower teams, and grow confidently.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/Melbourne.png"}
                text={"At Mobikode, we help businesses in Houston get more value from ServiceNow through practical, tailored consulting. From implementation and customization to integrations and ongoing support, our experts make complex workflows simpler and more efficient. We automate routine processes, improve user experiences, and build scalable ServiceNow solutions that help your team work smarter and support long-term digital growth."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we help Houston businesses get more from ServiceNow through tailored consulting and smart automation that simplify work, boost efficiency, and improve experiences. " />
            <HireDeveloper /> */}
        </div>
    )
}

export default Houston
